import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useLocales } from '../../../locales';
import humanizeDuration from 'humanize-duration';
import { useEffect, useState } from 'react';

import { COMMUNICATION_ENABLE_BASIC_STATISTICS } from '../constants';
import FeaturesToolTip from '../../featuresToolTip';

export function Statistics({ statistics, t }) {
  const { currentLang } = useLocales();

  const getFullTime = (diffInSeconds) => {
    if (!diffInSeconds) return '-';

    const humanizer = humanizeDuration.humanizer({
      language: currentLang.systemValue, // assuming currentLang.systemValue holds the language code
      units: ['d', 'h', 'm', 's'], // specify the units you want to use
      round: true, // rounds the smallest unit
      delimiter: ' ' // delimiter between units
    });

    return humanizer(diffInSeconds * 1000); // convert seconds to milliseconds as humanize-duration works with ms
  };

  const shortedDate = (diffInSeconds) => {
    if (!diffInSeconds) return '-';

    // Configure humanize-duration options
    const options = {
      language: currentLang.systemValue, // assuming currentLang.systemValue holds the language code
      units: ['y', 'mo', 'w', 'd', 'h', 'm', 's'], // specify the units you want to use
      round: true, // round the smallest unit
      largest: 1, // only show the largest unit
      languages: {
        // Adding a custom language for unique 'second' representation
        customLang: {
          ...humanizeDuration.getSupportedLanguages()[currentLang.systemValue],
          s: () => t('dates.shortLabelSeconds'),
          y: () => t('dates.shortLabelYears'),
          mo: () => t('dates.shortLabelMonths'),
          w: () => t('dates.shortLabelWeeks'),
          d: () => t('dates.shortLabelDays'),
          h: () => t('dates.shortLabelHours'),
          m: () => t('dates.shortLabelMinutes')
        }
      }
    };
    const humanizer = humanizeDuration.humanizer(options);

    return humanizer(diffInSeconds * 1000, { language: 'customLang' });
  };

  const [statsArray, setStatsArray] = useState([
    {
      label: 'communication.general_info.messages_count',
      value: statistics?.messages_count
    },
    {
      label: 'communication.general_info.answers_count',
      value: statistics?.answers_count
    },
    {
      label: 'communication.general_info.notes_count',
      value: statistics?.notes_count
    },
    {
      label: 'communication.general_info.avg_answer_time',
      value: shortedDate(statistics?.avg_answer_time),
      tooltip: getFullTime(statistics?.avg_answer_time)
    },
    {
      label: 'communication.general_info.max_answer_time',
      value: shortedDate(statistics?.max_answer_time),
      tooltip: getFullTime(statistics?.max_answer_time)
    },
    {
      label: 'communication.general_info.min_answer_time',
      value: shortedDate(statistics?.min_answer_time),
      tooltip: getFullTime(statistics?.min_answer_time)
    }
  ]);
  useEffect(() => {
    setStatsArray([
      {
        label: 'communication.general_info.messages_count',
        value: statistics?.messages_count
      },
      {
        label: 'communication.general_info.answers_count',
        value: statistics?.answers_count
      },
      {
        label: 'communication.general_info.notes_count',
        value: statistics?.notes_count
      },
      {
        label: 'communication.general_info.avg_answer_time',
        value: shortedDate(statistics?.avg_answer_time),
        tooltip: getFullTime(statistics?.avg_answer_time)
      },
      {
        label: 'communication.general_info.max_answer_time',
        value: shortedDate(statistics?.max_answer_time),
        tooltip: getFullTime(statistics?.max_answer_time)
      },
      {
        label: 'communication.general_info.min_answer_time',
        value: shortedDate(statistics?.min_answer_time),
        tooltip: getFullTime(statistics?.min_answer_time)
      }
    ]);
  }, [statistics]);
  const overlay = (stat) => {
    if (stat.tooltip)
      return (
        <Tooltip>
          <span className="fw-bold text-muted">{stat.tooltip}</span>
        </Tooltip>
      );
    return <></>;
  };
  const { userData } = useSelector((state) => state.userDetails);

  return (
    <div className="card m-2 p-4 shadow w-100">
      <b className="text-muted m-0 mb-2 p-0 fs-6 fw-bold">
        {t('communication.general_info.statistics')}
      </b>
      <table border="0" className="w-100 mx-2">
        <tbody>
          {statsArray.map((stat, index) => (
            <tr key={index} className="w-100">
              <td className="p-1 fw-bold text-muted">{t(stat.label)}:</td>
              <td className="p-1 fw-bold text-muted flex-end text-end">
                {userData?.feature_list_for_user[
                  COMMUNICATION_ENABLE_BASIC_STATISTICS
                ] ? (
                  <OverlayTrigger placement="top" overlay={overlay(stat)}>
                    <span className="cursor-pointer">{stat.value}</span>
                  </OverlayTrigger>
                ) : (
                  <FeaturesToolTip
                    featureIsActive={
                      userData?.feature_list_for_user[
                        COMMUNICATION_ENABLE_BASIC_STATISTICS
                      ]
                    }
                    feature={COMMUNICATION_ENABLE_BASIC_STATISTICS}
                    InnerComponent={() => <>-</>}
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
